import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";
import type { DashboardData } from "../../types/dashboard-data.type";
import type { CertificatesResponse } from "../../types/certificates.type";

interface DownloadReportSuccessData {
	download_url: string;
	filename: string;
	expires_in: number;
}

interface ReportInfoSuccessData {
	file_name: string | null;
	file_size: number | null;
	last_modified: string | null;
}

interface DocsSuccessData {
	content: string;
}

interface DocsClickRequestData {
	timestamp?: string | null;
	page?: string | null;
	agent_version?: string | null;
	session_id?: string | null;
	buyer_id?: number | null;
}

interface DocsClickSuccessData {
	status: "ok" | string;
}

// type DashboardData = Record<string, unknown>;

export type IDownloadReportResponse = IResponse<DownloadReportSuccessData>;
export type IGetReportInfoResponse = IResponse<ReportInfoSuccessData>;
export type IGetDocsResponse = IResponse<DocsSuccessData>;
export type ILogDocsClickResponse = IResponse<DocsClickSuccessData>;
export type IGetDashboardDataResponse = IResponse<DashboardData>;
export type IGetCertificatesResponse = IResponse<CertificatesResponse>;

export async function downloadReport(): Promise<IDownloadReportResponse> {
	return await apiRequest<DownloadReportSuccessData>({
		path: "/api/ui/download-report",
		method: "GET",
	});
}

export async function getReportInfo(): Promise<IGetReportInfoResponse> {
	return await apiRequest<ReportInfoSuccessData>({
		path: "/api/ui/get-report-info",
		method: "GET",
	});
}

export async function getDocs(): Promise<IGetDocsResponse> {
	return await apiRequest<DocsSuccessData>({
		path: "/api/ui/docs",
		method: "GET",
	});
}

export async function logDocsClick(
	body: DocsClickRequestData,
): Promise<ILogDocsClickResponse> {
	return await apiRequest<DocsClickSuccessData>({
		path: "/api/ui/docs-click",
		method: "POST",
		json: body,
	});
}

export async function getDashboardData(): Promise<IGetDashboardDataResponse> {
	return await apiRequest<DashboardData>({
		path: "/api/v1/ui/dashboard-data",
		method: "GET",
		credentials: "include",
	});
}

export async function getCertificates(): Promise<IGetCertificatesResponse> {
	return await apiRequest<CertificatesResponse>({
		path: "/api/v1/ui/certificates",
		method: "GET",
		credentials: "include",
	});
}
